export default "/public/dist/img/Cosefoto_2.jpg";